import http from '../request';

export const articlelist = (params: IArticleParams): RES<IArticleModel> => http.post("/system/article/list1", params)

export const articlesget = (): RES<IArticleModel> => http.get("/system/article/get")
